import type { ComboboxItem } from '@node-space/ui-components'
import { CustomerV2Status } from 'types/customers'

export const statusVariantMap: Partial<Record<CustomerV2Status, 'success' | 'warning' | 'error'>> =
  {
    APPROVED: 'success',
    SUBMITTED: 'warning',
    IN_REVIEW: 'warning',
    REJECTED: 'error',
    NOT_STARTED: 'warning',
  }

export const getOptions = (
  map: Record<string, string>,
  translationPrefix: string,
  t: (key: string) => string
) =>
  Object.keys(map).map(key => ({
    value: map[key],
    leftText: t(`${translationPrefix}.${key}`),
  }))

export const findLabel = (items: ComboboxItem[], value: string | undefined): string | undefined =>
  items.find(item => item.value === value)?.leftText as string | undefined

export const booleanDisplay = (value: string | undefined, yes: string, no: string): string => {
  if (value === 'true') return yes
  if (value === 'false') return no
  return ''
}
